import { SendVerificationEmailRequest } from '@aaa-ncnu-ie/mypolicy-api-registrations';
import { useMutation } from '@tanstack/react-query';

import axios from '../../axios';

// this service actually sends an email to the user for them to verify the email address entered
export const emailConfirmation = async (
  requestBody: SendVerificationEmailRequest
) => {
  const { data } = await axios.post(
    `${import.meta.env.VITE_REGISTRATIONS_API_URL}/v1/mail/send
    `,
    requestBody
  );

  return data;
};

export const useEmailConfirmationMutation = () =>
  useMutation({
    mutationFn: (requestBody: SendVerificationEmailRequest) =>
      emailConfirmation(requestBody),
  });
